<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
</script>
<template>
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
        <div class="container">
            <div class="row p-5 text-center" v-if="showSuccess">
                <p class="title" role="button" v-html="translate.msgSuccess" @click="redirect('LoginPage')"></p>
            </div>            
            <div class="row p-5 text-center" v-if="showWaiting">
                <p class="title">{{ translate.msgWaiting }}</p>
            </div>            
            <div class="row p-5 text-center" v-if="showFailed">
                <p class="title">{{ translate.checkFailedText1 }}</p>
                <p class="text" v-html="translate.checkFailedText2"></p>
            </div>
            <div class="row p-5" v-if="showConfirmed">
                <div class="container">
                    <div class="row mt-2">
                        <div class="col-lg-12 text">
                            {{ translate.pwdReset }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-12">
                            <form @submit.prevent="savePassword(showModalMessages)">                            
                                <div class="form-group mt-3">
                                    <input readonly type="text" class="form-control" id="inputEmail" aria-describedby="emailHelp"
                                        :placeholder="translate.formResetEmail" name="email" v-model="email">
                                </div>
                                <div class="form-group mt-4">
                                    <div class="input-group">                                
                                        <input v-if="hidden" type="password" class="form-control" name="password" id="inputPassword"
                                            :placeholder="translate.formResetPwd" autocomplete="current-password" v-model="password">
                                        <input v-if="!hidden" type="text" class="form-control" name="password" id="inputPassword2"
                                            :placeholder="translate.formResetPwd" autocomplete="current-password" v-model="password">
                                        <i @click="hiddenPassword" class=" input-group-text icon-eye"></i>
                                    </div>
                                </div>
                                <div class="form-group mt-3">
                                    <div class="input-group">                                
                                        <input v-if="hidden2" type="password" class="form-control" name="password_confirmation" id="inputPasswordConfirmation"
                                            :placeholder="translate.formResetPwdConfirm" autocomplete="current-password_confirmation" v-model="passwordConfirmation">
                                        <input v-if="!hidden2" type="text" class="form-control" name="password_confirmation" id="inputPasswordConfirmation2"
                                            :placeholder="translate.formResetPwdConfirm" autocomplete="current-password_confirmation" v-model="passwordConfirmation">
                                        <i @click="hiddenPassword2" class=" input-group-text icon-eye"></i>
                                    </div>
                                </div>
                                <div class="text-center mt-3" v-if="loading">
                                    <div class="spinner-border" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                <div class="col-4 d-w-btn" v-else>
                                    <button> {{ translate.formResetButton }} <i class="icon-arrow-right"></i></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent, resolveDirective } from 'vue'
import api from '../../api'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/myaccount'
import router from '../../router'

export default defineComponent({
  name: 'PasswordResetPage',
  emits: ['showModalMessages'],  
  computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
          if (this.locale === 'pt-br') {
              return tradutor.portugues
          } else {
              return tradutor.ingles
          }
      }
  },

  data() {
    return {
        showWaiting: true,
        showSuccess: false,        
        showFailed: false,
        showConfirmed: false,
        email: this.$route.params.email,
        password: '',
        passwordConfirmation: '',
        loading: false,
        hidden: true,
        hidden2: true,
    }
},

  created() {
    this.checkMailAndToken()
  },
  methods: {
    hiddenPassword() {
      this.hidden = !this.hidden
    },
    hiddenPassword2() {
      this.hidden2 = !this.hidden2
    },
    checkMailAndToken() {
        api.get('v1/password/checkToken/?email='+this.$route.params.email+'&token='+this.$route.params.token).then(({ data }) => {
            this.showWaiting = false
            if (data.returnStatus == "failed") {
                this.showFailed = true
            } else if (data.returnStatus == "confirmed") {
                this.showConfirmed = true
            }
        }).catch((error) => console.log(error))
    },
    savePassword(message) {
        this.loading = true
        let requestOptions = {
            'token': this.$route.params.token,            
            'email': this.email,
            'password': this.password,
            'password_confirmation': this.passwordConfirmation,
            'locale': this.locale
        }
        api.post('v1/password/reset', requestOptions).then(({ data }) => {
            if (data["error"]) {
                message({message: {show: true,title: '',textBoby: data["error"]["message"], textButton: this.translate.btnClose }})
            } else {
                message({message: {show: true,title: '',textBoby: data["success"]["message"], textButton: this.translate.btnClose }})
                this.showSuccess = true
                this.showConfirmed = false
            }
            this.loading = false
        })    
    },
    redirect(name) {
      router.push({ name, params: { locale: this.locale } })
    }

  }
})
</script>

<style scoped lang="css">

.slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
    font-size: 20px;
}

.title {
    margin-top: 30px;
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
}

.text {
    margin-top: 10px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 25px;
}

#inputPassword2 {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

#inputPasswordConfirmation2 {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.icon-eye:before {
  color: #ced4da;
  margin-right: 0.5em;
  cursor: pointer;
}

.input-group-text {
  padding: 0;
  padding-left: 5px;
  font-size: 2rem;
  background-color: #f8f8f8;
  border: 1px solid #ced4da;
  border-radius: 30px;
  border-left-style: hidden;
  height: 51px;
}

input[type=text]:focus {
    background-color: #f8f8f8;
}    
input[type=password]:focus {
    background-color: #f8f8f8;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {

}
</style>
